import DriverPlanEntryCheckoutEventDeleteRequest from "../../../../../api/raily/driver/plan-entry/checkout-event/delete/driver-plan-entry-checkout-event-delete.request";
import DriverPlanEntryCheckoutEventDeleteParams from "./driver-plan-entry-checkout-event-delete-params";

const create = (
  params: DriverPlanEntryCheckoutEventDeleteParams,
): DriverPlanEntryCheckoutEventDeleteRequest => {
  return {
    checkoutEventUuid: params.checkoutEventUuid,
    driverUuid: params.driverUuid,
    planEntryUuid: params.planEntryUuid,
  };
};

const driverPlanEntryCheckoutEventDeleteParamsFactory = {
  create,
};

export default driverPlanEntryCheckoutEventDeleteParamsFactory;
